var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M82 40.76H70.44C60.96 40.76 53.24 33.04 53.24 23.56V12C53.24 9.8 51.44 8 49.24 8H32.28C19.96 8 10 16 10 30.28V65.72C10 80 19.96 88 32.28 88H63.72C76.04 88 86 80 86 65.72V44.76C86 42.56 84.2 40.76 82 40.76Z",
    fill: "#F2654E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2007 8.83997C61.5607 7.19997 58.7207 8.31997 58.7207 10.6V24.56C58.7207 30.4 63.6807 35.24 69.7207 35.24C73.5207 35.28 78.8007 35.28 83.3207 35.28C85.6007 35.28 86.8007 32.6 85.2007 31C79.4407 25.2 69.1207 14.76 63.2007 8.83997Z",
    fill: "#F2654E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54 55H30C28.36 55 27 53.64 27 52C27 50.36 28.36 49 30 49H54C55.64 49 57 50.36 57 52C57 53.64 55.64 55 54 55Z",
    fill: "#F2654E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46 71H30C28.36 71 27 69.64 27 68C27 66.36 28.36 65 30 65H46C47.64 65 49 66.36 49 68C49 69.64 47.64 71 46 71Z",
    fill: "#F2654E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.8bfc92323c4a86b34f00abde3e74605e.svg";
export { ForwardRef as ReactComponent };